module.exports = new __parcel__URL__("machines_laser_cannon_level_4.1213f65f.png").toString();